module.exports = __webpack_public_path__ + "img/bg-top.62af3b61.svg";